var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88305 1.59949L1.37305 5.13757H4.88305V1.59949Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6026 14.2453L14.6289 15.2268L18.0654 18.6908L19.0391 17.7093L15.6026 14.2453Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8227 14.8537C9.93174 14.8537 9.12173 14.5816 8.41973 14.1461H2.85773V13.3841H7.47473C6.93473 12.8125 6.55674 12.0777 6.36773 11.2884H2.85773V10.5264H6.25973C6.25973 10.4447 6.25973 10.3631 6.25973 10.2542C6.25973 9.60105 6.39474 8.97508 6.63774 8.43076H2.85773V7.66871H7.06973C7.90673 6.47121 9.25673 5.68194 10.8227 5.68194C12.4157 5.68194 13.8197 6.52564 14.6297 7.77758V0.701416H5.63873V5.9541H0.427734V20.5963H14.6297V12.7853C13.8197 14.01 12.4157 14.8537 10.8227 14.8537Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06863 12.8942C8.77063 13.629 9.74263 14.0917 10.8226 14.0917C12.9286 14.0917 14.6296 12.3771 14.6296 10.2542C14.6296 8.13138 12.9286 6.41677 10.8226 6.41677C9.25663 6.41677 7.90663 7.39655 7.31263 8.75735H11.3086V10.1454H7.01562C7.01562 10.1726 7.01562 10.1998 7.01562 10.227C7.01562 10.6625 7.09662 11.0979 7.23162 11.479H11.3086V12.867H8.06863V12.8942Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailActive);
export default __webpack_public_path__ + "static/media/detailActive.fad2236b3daaff66642510e76f0c9967.svg";
export { ForwardRef as ReactComponent };